import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChartModel } from 'src/app/models/chart.model';
import { ChartsService, PushEditForm } from 'src/app/services/charts.service';
import { DealersService } from 'src/app/services/dealers.service';
import { Dealer } from 'src/app/models/dealer.model';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { UserService } from 'src/app/services/user.service';
import { BooleanFilterMenuComponent } from '@progress/kendo-angular-grid';
import { ColumnLockedChangeEvent } from '@progress/kendo-angular-grid/dist/es2015/column-menu/column-locked-change-event';

@Component({
  selector: 'app-manage-chart',
  templateUrl: './manage-chart.component.html',
  styleUrls: ['./manage-chart.component.scss']
})

export class ManageChartComponent implements OnInit {


  constructor(public dialogRef: MatDialogRef<ManageChartComponent>, private clickstream: ClickStreamService, private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: ChartModel, private chartsService: ChartsService, private dealersService: DealersService, private router: Router, private _snackBar: MatSnackBar) { }
  tableData :TData[] = [];
  isConfirm: boolean = false;
  isSelected: boolean = false;
  selectedChartsGroups: any[] = [];
  groupsByTimeFrame = new Map<number, any[]>();
  isLoading = true;
  dealersForTimeFrame = new Map<number, Dealer[]>();
  deleteId: number;
  userType: string;

  displayColumns: string[] = ['country', 'schedule', 'manage'];
  columns: ColumnDefinition[] = [
    { columnDef: 'country', header: 'Country', cell: (w: any) => `${w.country}` },
    { columnDef: 'schedule', header: 'Display Schedule', cell: (w: any) => `${w.schedule}` },
  ];

  ngOnInit(): void {
    this.userType = this.userService.user.businessFunction;
    this.getChart(this.data.chartDataGuid);
  }


  getChart(chartDataGuid) {
    this.tableData = [];
    this.isLoading = true;
    this.chartsService.getGroupsForChart(chartDataGuid).subscribe((groups: any) => {
      groups.forEach(g => {
        var data = new TData();
        data.insightAccessGuid = g.guid;
        data.schedule = g.timeFrame;
        data.country = g.country.fullName;
        data.isSelected = false;
        this.tableData.push(data);
      });
      this.isLoading = false;
    })
  }

  confirmOn(insightAccessGuid) {
    this.isConfirm = true;
    this.deleteId = insightAccessGuid;
  }

  delete(insightAccessGuid) {
    this.chartsService.removeGroupsFromChart(insightAccessGuid).subscribe(res => {
      // this.getChart(this.data.id);
      this._snackBar.open('Schedule Deleted Successfully', 'Close', { duration: 2000 });
      this.tableData = this.tableData.filter(d => d.insightAccessGuid != insightAccessGuid);
      if (this.tableData.length == 0) this.close({ removeRow: true });
      else this.isConfirm = false;
      this.clickstream.send('delete-pushed-chart', 'click', 'Manage ChartModel Dialog', 'Delete Push', '', true);
    }, error => { this._snackBar.open('Something went wrong! Try again', 'Close', { duration: 2000 }); })

  }

  formatTimeFrame(tf): string {
    return this.chartsService.formatTimeFrame(tf).charAt(0).toUpperCase() + this.chartsService.formatTimeFrame(tf).slice(1);
  }

  clickEdit(timeFrame) {
    this.dialogRef.close();
    this.router.navigate(['/admin/push-chart', this.data.chartDataGuid, timeFrame.id]);
    this.clickstream.send('edit-pushed-chart', 'click', 'Manage ChartModel Dialog', 'Edit Push', '', true);
  }

  goBack() {
    this.isConfirm = false;
  }

  close(result?) {
    this.dialogRef.close(result);
    this.clickstream.send('edit-pushed-chart', 'click', 'Manage ChartModel Dialog', 'Edit Push', '', true);
  }
}

class TData {
  country: string;
  schedule: string;
  insightAccessGuid: string;
  isSelected: boolean;
};